import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { ReactElement } from 'react';

export type ConfirmDialogProps = {
  open: boolean;
  title: string;
  message?: string;
  content?: ReactElement;
  actions: ReactElement[];
  onClose?: () => void;
  disableRestoreFocus?: boolean;
};

export const ConfirmDialog = (props: ConfirmDialogProps) => {
  const { open, title, message, content, actions, disableRestoreFocus } = {
    ...props,
  };
  return (
    <Dialog
      open={open}
      onClose={props.onClose}
      disableRestoreFocus={disableRestoreFocus}
    >
      {title != null && <DialogTitle>{title}</DialogTitle>}
      {message != null && (
        <DialogContent>
          <Typography textAlign="center">{message}</Typography>
        </DialogContent>
      )}
      {content != null && <DialogContent>{content}</DialogContent>}
      <DialogActions>
        <Box
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
          gap={1}
          width={1}
        >
          {actions}
        </Box>
      </DialogActions>
    </Dialog>
  );
};
